<template>
  <model :show="!!photoData" @close="close" class="show-photo">
    <div class="image">
      <img :src="photoData.imageUrl" :alt="photoData.title" @click="close">
    </div>
  </model>
</template>
<script>
import Model from "~/components/Model.vue"
import { getPhoto } from '@/services/photos'

export default {
  props: {
    photoId: Number
  },
  data() {
    return {
      photoData: null,
      prev: false,
      next: false,
    }
  },
  components: { Model },
  methods: {
    close() {
      this.$emit('close')
      this.photoData = null
    }
  },
  watch: {
    photoId() {
      if (this.photoId) {
        getPhoto(this.photoId).then((resp) => this.photoData = resp.data)
      }
    }
  }
}
</script>
